import React from "react"
import { GameRulesConainer } from "./GameRulesStyles"
import AboutGameRules from "./components/AboutGameRules"
import PlaceBet from "./components/PlaceBetRules"
import WinRules from "./components/WinRules"
import AutoplayRules from "./components/AutoplayRules"
import GeneralRules from "./components/GeneralRules"

export default function GameRules() {
  return (
    <GameRulesConainer>
      <AboutGameRules />
      <PlaceBet />
      <WinRules />
      <AutoplayRules />
      <GeneralRules />
    </GameRulesConainer>
  )
}
